// src/components/InlineSVG/index.jsx

import React, { useState, useEffect } from 'react';

// O componente recebe suas props. A única prop que ele precisa é 'url'.
const InlineSVG = ({ url }) => {
  const [svgText, setSvgText] = useState('');

  useEffect(() => {
    // Se a URL não for fornecida, não faz nada.
    if (!url) return;

    fetch(url)
      .then(res => res.text())
      .then(text => setSvgText(text))
      .catch(console.error);
  }, [url]); // Executa novamente se a URL mudar

  // Este div vai renderizar o código do SVG que foi baixado
  // ATENÇÃO: É seguro aqui pois o SVG vem de uma fonte confiável (seu CMS).
  return <div dangerouslySetInnerHTML={{ __html: svgText }} />;
};

// AQUI ESTÁ A CORREÇÃO PRINCIPAL: Exportando o componente como padrão
export default InlineSVG;